import { createContext, useContext, useState } from 'react'

const ProfileTabContext = createContext({
  currentTabIndex: 0,
  setCurrentTabIndex: () => {},
})

export const ProfileTabProvider = ({ children }) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0)

  return (
    <ProfileTabContext.Provider
      value={{ currentTabIndex, setCurrentTabIndex }}
    >
      {children}
    </ProfileTabContext.Provider>
  )
}

export const useProfileTab = () => useContext(ProfileTabContext)
